import {
  Box,
  Button,
  FormControl,
  FormLabel,
  Heading,
  Input,
  Table,
  TableContainer,
  Tbody,
  Td,
  Text,
  Th,
  Thead,
  Tr,
} from "@chakra-ui/react";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import Select from "react-select";
import MainModel from "../../../components/Models/main-model";
import {
  createPracticeSubscriptionRequest,
  getPracticeSubjectsRequest,
  getPracticeUsersRequest,
} from "../../../modules/admin-modules/asquera-practice/Actions";
import {
  formatDateTime,
  getSubscriptionSubjectName,
  getUserSubscriptions,
  oneMonthFromNow,
  toApiDateTime,
} from "./helpers";

const colourStyles = {
  control: (styles) => ({
    ...styles,
    width: "100%",
    background: "#f5f5f5",
    color: "#690000",
    borderRadius: "16px",
  }),
  option: (styles) => ({ ...styles, color: "#690000" }),
};

const UserSubscriptionsModal = ({ isOpen, onClose, user, searchTerm }) => {
  const dispatch = useDispatch();
  const subjects = useSelector((state) => state.asqueraPractice.subjects);
  const createLoading = useSelector(
    (state) => state.asqueraPractice.createLoading
  );

  const [subjectId, setSubjectId] = useState(null);
  const [amount, setAmount] = useState("");
  const [expiresAt, setExpiresAt] = useState(oneMonthFromNow());

  useEffect(() => {
    if (isOpen) {
      dispatch(getPracticeSubjectsRequest());
      setSubjectId(null);
      setAmount("");
      setExpiresAt(oneMonthFromNow());
    }
  }, [isOpen, dispatch]);

  const subjectOptions = Array.isArray(subjects)
    ? subjects.map((subject) => ({
        value: subject.id,
        label: subject.name || subject.title,
      }))
    : [];

  const subscriptions = getUserSubscriptions(user);

  const header = (
    <Box>
      <Heading textAlign="center" color="main_1" fontSize="24px">
        اشتراكات {user?.name || ""}
      </Heading>
      <Text textAlign="center" color="gray.600" fontSize="14px" mt={2}>
        {user?.user_name || "-"} | {user?.phone || "-"}
      </Text>
    </Box>
  );

  const handleCreate = () => {
    if (!user?.id || !subjectId) return;

    const payload = {
      user_id: user.id,
      subject_id: subjectId,
      expires_at: toApiDateTime(expiresAt),
    };

    if (amount !== "" && amount !== null && amount !== undefined && !Number.isNaN(Number(amount))) {
      payload.amount = Number(amount);
    }

    dispatch(
      createPracticeSubscriptionRequest(payload, () => {
        dispatch(getPracticeUsersRequest(1, searchTerm || ""));
        setSubjectId(null);
        setAmount("");
        setExpiresAt(oneMonthFromNow());
      })
    );
  };

  return (
    <MainModel
      header={header}
      openVar={isOpen}
      closeFunc={onClose}
      size="4xl"
    >
      <Box mb={6}>
        <Text fontSize="18px" fontWeight="600" color="main_1" mb={3}>
          سجل الاشتراكات
        </Text>
        {subscriptions.length === 0 ? (
          <Text color="gray.500">لا توجد اشتراكات سابقة</Text>
        ) : (
          <TableContainer>
            <Table variant="simple" size="sm">
              <Thead>
                <Tr>
                  <Th>المادة</Th>
                  <Th>المبلغ</Th>
                  <Th>تاريخ الانتهاء</Th>
                  <Th>تاريخ الإنشاء</Th>
                </Tr>
              </Thead>
              <Tbody>
                {subscriptions.map((subscription, index) => (
                  <Tr key={subscription.id || index}>
                    <Td>{getSubscriptionSubjectName(subscription, subjects)}</Td>
                    <Td>{subscription.amount ?? "-"}</Td>
                    <Td>{formatDateTime(subscription.expires_at)}</Td>
                    <Td>
                      {formatDateTime(
                        subscription.created_at || subscription.start_date
                      )}
                    </Td>
                  </Tr>
                ))}
              </Tbody>
            </Table>
          </TableContainer>
        )}
      </Box>

      <Box
        borderTop="1px solid"
        borderColor="gray.200"
        pt={5}
      >
        <Text fontSize="18px" fontWeight="600" color="main_1" mb={4}>
          إضافة اشتراك جديد
        </Text>
        <FormControl isRequired mb={4}>
          <FormLabel>المادة</FormLabel>
          <Select
            options={subjectOptions}
            styles={colourStyles}
            placeholder="اختر المادة"
            value={
              subjectOptions.find((option) => option.value === subjectId) ||
              null
            }
            onChange={(option) => setSubjectId(option?.value || null)}
          />
        </FormControl>
        <FormControl mb={4}>
          <FormLabel>المبلغ (اختياري)</FormLabel>
          <Input
            type="number"
            value={amount}
            onChange={(e) => setAmount(e.target.value)}
            placeholder="المبلغ"
            bg="#f5f5f5"
          />
        </FormControl>
        <FormControl isRequired mb={6}>
          <FormLabel>تاريخ الانتهاء</FormLabel>
          <Input
            type="datetime-local"
            value={expiresAt}
            onChange={(e) => setExpiresAt(e.target.value)}
            bg="#f5f5f5"
          />
        </FormControl>
        <Button
          color="white"
          bg="main_1"
          _hover={{ bg: "main_1" }}
          onClick={handleCreate}
          isLoading={createLoading}
          isDisabled={!subjectId || !expiresAt}
          minW="200px"
        >
          إضافة اشتراك
        </Button>
      </Box>
    </MainModel>
  );
};

export default UserSubscriptionsModal;
